import api from 'src/config/api';
import {
	ICreateQuestionnaireSubmissionRequest,
	IQuestionnaire,
} from 'src/features/questionnaire/domain/types';

export const questionnaireApi = {
	getQuestionnaireSubmission: async (
		questionnaireId: number,
		siteSlug: string,
		studyId?: number,
		studyAssignmentId?: number,
	): Promise<IQuestionnaire> => {
		const params = new URLSearchParams({
			questionnaire_id: JSON.stringify(questionnaireId),
		});

		const path = studyAssignmentId
			? `/api/v1/study-assignment/${studyAssignmentId}/questionnaire-submission?${params}`
			: `/api/v1/study/${studyId}/questionnaire-submission?${params}`;

		const response = await api.get(path, {
			headers: {
				Site: siteSlug,
			},
		});

		return response.data;
	},

	createQuestionnaireSubmission: async (
		requestBody: ICreateQuestionnaireSubmissionRequest,
		siteSlug: string,
	): Promise<void> => {
		const response = await api.post(
			`/api/v1/questionnaire/submission`,
			requestBody,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);

		return response.data;
	},
};
